import * as React from "react";
import { styled } from "@mui/material";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const base = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 1009 380",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#355383",
			d: "M107.1 0h371.7c22 0 40 18 40 40v194.2H107V0Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#031839",
			d: "M107.1 0h8.6a40 40 0 0 1 40 40v339.2h-48.6V0ZM942 289h48v90h-48z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#355383",
			d: "M372 234.2h603a34 34 0 1 1 0 68H372v-68Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#031839",
			d: "M124.1 234.2h603a34 34 0 1 1 0 68H124v-68Zm554.3 68H727v77h-48.6z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#99B7E7",
			d: "M188.4 225.4c-26.6-15-27.4-56.2-26-76.8a17 17 0 0 1 12.8-15.3c23.9-6.6 79.5-18.6 112-.7 20.6 11.5 49.6 38.8 70 59.3a18.5 18.5 0 0 1-10.1 31.4c-46.8 8-128.7 18.9-158.7 2Z"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 316.3,
			cy: 156.8,
			fill: "#FFCAAE",
			rx: 43.7,
			ry: 55.5,
			transform: "rotate(-61 316.3 156.8)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#031839",
			d: "M314.5 140.5c5.9-12.8-9-22-9-22s9.4-6.6 25.3 0c7.1 3 5.7-3.5 5.7-3.5s-15-21.3-35.3-18.4c-12.8 1.8-10.5 7.7-21.5 14.6-9.6 6-15.4 3.2-24.3 15-6.5 8.5-20 22-13.8 31.2 2.6 3.7 5.3 2 7.3 6 3.2 6.5-2 12.6 6.5 16.2 3.8 1.7 3.5 2.2 6.9 4.5 65.2 45.4 88.3 12.9 88.3 12.9s-7.2-6-14.1-17.4c-5.2-8.5-28.5-25-22-39.1Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFB893",
			d: "M327.5 151.5c2.5 3.3 8 7.2 5 9.4-3.2 2.1-10.5-.3-13.7-5-3.2-4.5-3.3-10-.2-12.2 3.2-2.1 6 4.2 8.9 7.8Z"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 317.1,
			cy: 156.5,
			fill: "#FFCAAE",
			rx: 54,
			ry: 68.5,
			transform: "rotate(-61 317.1 156.5)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#031839",
			d: "M287 127.7c7.3-15.8-2.5-18.5-2.5-18.5s30.9-8.1 50.5 0c8.8 3.6 24.5 13 24.5 13s-36-43.6-61-40c-15.8 2.3-13 9.5-26.5 18-11.9 7.5-19 4-30 18.5-8 10.5-24.7 27.3-17 38.5 3.2 4.6 6.4 2.5 9 7.5 4 8-2.5 15.5 8 20 4.6 2 3.4 5.2 8.5 5.5a69.4 69.4 0 0 1 37 11.8s-4-3.4-12.5-17.3c-6.3-10.5 4-39.5 12-57Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#FFA879",
			strokeLinecap: "round",
			strokeWidth: 2,
			d: "M324.1 175c1 5-2 13 2 13.8 5 1.1 8-6.8 8-6.8m2.9 17.5s12.1-3 15.1-8c3.1-5.1-.4-17.5-.4-17.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#031839",
			strokeLinecap: "round",
			strokeWidth: 3,
			d: "M317 155.6s7.7-.5 9.6-4.7c1.7-3.6-1.7-8.9-1.7-8.9"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#031839",
			strokeLinecap: "round",
			strokeWidth: 2,
			d: "M316 129s-5.3 4.8-8.7 11c-3 5.4-3.6 10.2-3.6 10.2M293 165s-5.3 4.8-8.7 11c-3 5.4-3.6 10.2-3.6 10.2"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#031839",
			strokeLinecap: "round",
			strokeWidth: 3,
			d: "M296 188.4s7.7-.5 9.5-4.6c1.6-3.6-1.8-8.8-1.8-8.8"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFCAAE",
			d: "M365 115c4 5.7 4.8 13.3 1 16-3.8 2.7-12.9-.4-16.8-6-4-5.7-4-12.4-.2-15.1 3.8-2.7 12-.6 16 5.1Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#99B7E7",
			d: "M365.7 175.2a40 40 0 0 1 36.2-23h424.4a100 100 0 0 1 69.8 28.5l54.9 53.5H338l27.7-59Zm-92.5 39.9a12.5 12.5 0 0 1-5.8-8.2c-1.5-7.4 6.8-11.9 14.3-11a77.2 77.2 0 0 1 29 8c11.1 7.1 1.4 21.3-11.6 19a80.3 80.3 0 0 1-25.9-7.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ADC7EF",
			d: "m338 233.8 605-7.3s15.5 9.8 6 15.5c-11.7 7-47.1-1.4-76.4 0-22.2 1.1-32.3 4-54.7 4.9-38.6 1.4-59.2-5.7-98-4.9-27.7.6-40.7 4.5-68.4 4.9-33.7.4-50.7-5.4-84.4-4.9-34 .6-81.9 7.6-81.9 7.6s-60.4 3.1-95.9 0c-22-1.9-43.3-2-51.4-7.6-4.3-3 0-8.2 0-8.2Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ADC7EF",
			d: "m338 233.8 605-7.3s15.5 9.8 6 15.5c-11.7 7-47.1-1.4-76.4 0-22.2 1.1-32.3 4-54.7 4.9-38.6 1.4-59.2-5.7-98-4.9-27.7.6-40.7 4.5-68.4 4.9-33.7.4-50.7-5.4-84.4-4.9-34 .6-81.9 7.6-81.9 7.6s-60.4 3.1-95.9 0c-22-1.9-43.3-2-51.4-7.6-4.3-3 0-8.2 0-8.2Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ADC7EF",
			d: "m337 234.8 610.3 6.2s.6-11.4-4.3-14.5c-11.6-7.4-42.1 1.1-71.4-.4-22.2-1.1-42.7 2.7-65.1 1.9-38.6-1.5-48.8-1-87.6-1.9-27.6-.6-34.2 2.3-61.9 1.9-33.7-.5-52.8-9.4-86.5-10-34-.6-102.1 10-102.1 10s-36 5.4-75.6 1c-22-2.5-40.5-8.5-48.5-2.7-4.4 3.2-7.3 8.5-7.3 8.5Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#ADC7EF",
			d: "m337 234.8 610.3 6.2s.6-11.4-4.3-14.5c-11.6-7.4-42.1 1.1-71.4-.4-22.2-1.1-42.7 2.7-65.1 1.9-38.6-1.5-48.8-1-87.6-1.9-27.6-.6-34.2 2.3-61.9 1.9-33.7-.5-52.8-9.4-86.5-10-34-.6-102.1 10-102.1 10s-36 5.4-75.6 1c-22-2.5-40.5-8.5-48.5-2.7-4.4 3.2-7.3 8.5-7.3 8.5Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#355383",
			d: "M0 199h85v180H0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#355383",
			stroke: "#031839",
			strokeWidth: 8.3,
			d: "M89.2 203.1h119.7v171.7H89.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#031839",
			strokeWidth: 8.3,
			d: "M91.7 257.6h116.4"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#99B7E7",
			strokeWidth: 8.3,
			d: "M134.6 218h30.9m-30.9 56.1H166"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 126,
			height: 61,
			x: 30,
			y: 138,
			fill: "#031839",
			rx: 8
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 126,
			height: 61,
			x: 40,
			y: 138,
			fill: "#416AAB",
			rx: 8
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#355383",
			d: "M0 199h85v180H0z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#355383",
			stroke: "#031839",
			strokeWidth: 8.3,
			d: "M89.2 203.1h119.7v171.7H89.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#031839",
			strokeWidth: 8.3,
			d: "M91.7 257.6h116.4"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "#99B7E7",
			strokeWidth: 8.3,
			d: "M134.6 218h30.9m-30.9 56.1H166"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 126,
			height: 61,
			x: 40,
			y: 138,
			fill: "#416AAB",
			rx: 8
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 100,
			height: 33,
			x: 53,
			y: 146,
			fill: "#355383",
			rx: 4
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 56,
			cy: 188,
			r: 3,
			fill: "#99B7E7"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 66,
			cy: 188,
			r: 3,
			fill: "#99B7E7"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 76,
			cy: 188,
			r: 3,
			fill: "#99B7E7"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 86,
			cy: 188,
			r: 3,
			fill: "#99B7E7"
		})
	]
});
const SvgBed = styled(base)({});
export default SvgBed;
